import {
  Box,
  Form,
  mdBumps,
  ModalHeader,
  PrimaryButton,
  RadioButton,
  RadioButtonGrid,
} from '@wrisk/ui-components'
import React, { FormEvent, useCallback } from 'react'

import { Quote } from '../../../domain'
import { ExcessData } from '../../../hooks/adjustments/policy'
import { isVoluntaryExcess, useExcesses } from '../../../hooks/excess'
import {
  tFormats,
  TKey,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'

interface VoluntaryExcessModalProps {
  data: ExcessData
  onChange: (data: ExcessData) => void
  loading: boolean
  quote: Quote
}

const tKey = TKey('components.voluntary-excess-modal')

export const VoluntaryExcessModal: React.FC<VoluntaryExcessModalProps> = ({
  data,
  onChange,
  loading,
  quote,
}) => {
  const { t } = useWriskTranslation()

  const { voluntary } = useExcesses(quote)

  const excess = voluntary.find(isVoluntaryExcess(data.excessCode))

  const onEdit = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      onChange({
        excessCode: data.excessCode,
        excess: Number(new FormData(e.currentTarget).get('excess')),
      })
    },
    [onChange],
  )

  const radioInput = (
    <RadioButtonGrid width={1} columns={4}>
      {excess?.excesses?.map((it) => (
        <RadioButton
          key={it}
          name='excess'
          value={it}
          id={it.toString()}
          defaultChecked={it === excess?.excess}
          data-testid={`excess${it}`}
        >
          {t(tFormats('currency.short'), { amount: it })}
        </RadioButton>
      ))}
    </RadioButtonGrid>
  )

  return (
    <Box>
      <ModalHeader header={t(tKey('header'))} />
      <Form data-testid='excess-form' onSubmit={onEdit}>
        {radioInput}
        <PrimaryButton
          loading={loading}
          type='submit'
          data-testid='modal-button-save'
          mt={mdBumps}
          width={1}
          layout='fixed'
        >
          {t(tKey('actions.confirm'))}
        </PrimaryButton>
      </Form>
    </Box>
  )
}
